<template>
<div>
    <div class="gm-searchbar" v-if="infoType">
        <div class="gm-col gm-yl" style="flex-basis:70%">
            <div class="gm-lbl" style="flex-basis:25%">
                <label>
                    Your Location
                </label>
            </div>
            <div class="gm-tex" style="flex-basis:75%">
                <gmap-autocomplete @place_changed="setPlace" class="map-autocomplete" ref="gmapAutoComplete">
                </gmap-autocomplete>
            </div>
        </div>
        <!-- <div class="gm-col gm-sr">
        <div class="gm-lbl">
          <label>
            Search Radius
          </label>
        </div>
        <div class="gm-drp">
          <select class="form-control classic" name="EremitPayMapRadius" v-model="RadiusFieldId" data-vv-as='Radius'
              :class="{'input': true}">
              <option :value="null" disabled>Select Radius</option>
              <option :key="item.Id" v-for="item in radiusCollection" :value="item.Id">
                {{item.Text}}
              </option>
          </select>
        </div>
      </div> -->
        <div class="gm-col gm-btn">
            <button type="button" @click="usePlace" class="btn" v-if="infoType!='broadcast'" style="line-height:12px;">Search</button>
        </div>
    </div>
    <GmapMap :center="center" :zoom="zoom" style="width:100%;  height: 400px;" ref="gmap">
        <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" @click="toggleInfoWindowClick(m,index)" v-on:mouseover="toggleInfoWindow(m,index)">

        </GmapMarker>
        <GmapMarker :position="circleCenter" :label="'C'" v-if="this.displayCircle">

        </GmapMarker>

        <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
            <div v-html="infoContent"></div>
        </GmapInfoWindow>
        
    </GmapMap>
</div>
</template>

<script>
import Base from "../shared/Base";
import ListService from "../services/list";
export default {

    name: "GoogleMap",
    props: ["userdetails", "infoType"],
    watch: {
        userdetails: function () {
            this.UpdateTxnMarker();
        },
    },
    data() {
        return {
            RadiusFieldId: null,
            displayCircle: false,
            circleBounds: {},
            SearchMapAddress: null,
            SearchLocation: null,
            circleCenter: {
                lat: 0,
                lng: 0
            },
            center: {
                lat: 27.7172,
                lng: 85.324
            },
            markers: [],
            places: [],
            place: null,
            currentPlace: null,
            zoom: 12,
            infoWindowPos: {
                lat: 0,
                lng: 0
            },
            //optional: offset infowindow so it visually sits nicely on top of our marker
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            infoWinOpen: false,
            infoContent: null,

        };
    },

    mounted() {
        if (this.infoType) {
            this.UpdateTxnMarker();
        }

    },
    methods: {
        toggleInfoWindowClick: function (marker, idx) {

            if (this.infoType == 'eRemitPayPartnersGeo') {
                this.$emit('OnMarkerSelect', marker.Id);
            }
        },

        toggleInfoWindow: function (marker, idx) {
            if (!this.infoType) {
                return false;
            }
            this.infoWindowPos = marker.position;
            this.infoContent = this.getInfoWindowContent(marker);
            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
                this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
                this.infoWinOpen = true;
                this.currentMidx = idx;
            }
        },

        getInfoWindowContent: function (marker) {

            let info = "";
            if (this.infoType && this.infoType == "eRemitPayPartnersGeo") {
                console.log(marker);
                info = `<div class="card" style = "border:0;">
             <div class="card-content">
               <div class="content">
                  <p class="title is-4"><strong>${marker.Name}</strong></p>

                  ${marker.Address}
                  <br/><br/>
                  <strong>Phone:</strong>${marker.Phone}
                   <br/>
               </div>
             </div>
           </div>
      </div>
       `;
            }
            return info;
        },
        setPlace: function (place) {
            if (place.formatted_address) {
                this.SearchMapAddress = place.formatted_address;
            } else {
                this.SearchMapAddress = "";
            }
            this.circleCenter.lat = null;
            this.circleCenter.lng = null;
            this.displayCircle = false;
            //this.markers = [];
            this.place = place;
            if (!place.geometry) {
                this.SearchLocation = "";
            } else {
                this.SearchLocation = `${place.geometry.location.lat()},${place.geometry.location.lng()}`;
            }
            if (place.geometry.viewport) {
                this.$refs.gmap.fitBounds(place.geometry.viewport);
            } else {
                this.$refs.gmap.setCenter(place.geometry.location);
                this.$refs.gmap.setZoom(17); // Why 17? Because it looks good.
            }

        },

        UpdateTxnMarker() {
            if (this.infoType == "eRemitPayPartnersGeo") {
                // if(this.userdetails==undefined||null)
                //   return false;

                this.userdetails.map(x => {
                    if (x.Latitude && x.Longitude) {
                        let partner = {
                            Id: x.Id,
                            Name: x.TerminalName,
                            Address: x.Address,
                            Distance: x.Distance,
                            Phone: x.PhoneNumber,
                            position: {
                                lat: x.Latitude,
                                lng: x.Longitude,
                            }
                        }
                        this.markers.push(partner);
                    }
                })

            }

            this.$refs.gmap.$mapPromise.then(map => {
                const bounds = new google.maps.LatLngBounds();
                if (this.markers.length > 0) {
                    for (let m of this.markers) {
                        bounds.extend(m.position);
                    }
                    this.center.lat = this.markers[0].position.lat
                    this.center.lng = this.markers[0].position.lng
                } else {
                    navigator.geolocation.getCurrentPosition((position) => {
                        bounds.extend({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        });
                        this.center.lat = position.coords.latitude
                        this.center.lng = position.coords.longitude
                    });

                }
                map.fitBounds(bounds);
                var listener = google.maps.event.addListener(map, "idle", function () {
                    if (map.getZoom() > 16) map.setZoom(16);
                    google.maps.event.removeListener(listener);
                });
            });
            console.log(this.center)

        },
        usePlace: function (place) {
            let placeData = "";
            if (this.place && this.place.name) {
                placeData = this.place.name;
            }
            var searchobj = {};
            searchobj.SearchLocation = this.SearchLocation;
            if (this.circleCenter.lat) {
                searchobj.Location = `${this.circleCenter.lat},${this.circleCenter.lng}`
            } else {
                searchobj.Location = "";
            }
            searchobj.Radius = this.RadiusFieldId
            searchobj.SearchMapAddress = this.SearchMapAddress;
            this.markers = [];

            searchobj.SearchKeyword = this.$refs.gmapAutoComplete.$refs.input.value;
            this.$emit('OnSearchMap', searchobj)
        },

    }
};
</script>

<style>
input.map-autocomplete {
    width: 70%;
}

.gm-searchbar {
    background: #ddd;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 10px 0;
}

.gm-col.gm-yl {
    flex-basis: 40%;
    display: flex;
    flex-wrap: wrap;
}

.gm-col.gm-sr {
    flex-basis: 40%;
    display: flex;
    flex-wrap: wrap;
}

.gm-col.gm-btn {
    flex-basis: 13%;
    text-align: right;
}

.gm-col label,
.gm-col .gm-lbl {
    font-size: 14px;
    flex-basis: 40%;
    margin-top: 4px;
}

.gm-tex {
    flex-basis: 60%;
}

input.map-autocomplete {
    width: 100%;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 3px;
}

.gm-col.gm-btn .btn {
    border: 1px solid #aaa;
    padding: 11px;
}

/* .web-application .form-card .form-card-forms {
    padding: 20px 15px; 
} */
</style>
